/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { creditHistoryLogControllerCreate } from '../fn/credit-history-log/credit-history-log-controller-create';
import { CreditHistoryLogControllerCreate$Params } from '../fn/credit-history-log/credit-history-log-controller-create';
import { creditHistoryLogControllerFindAll } from '../fn/credit-history-log/credit-history-log-controller-find-all';
import { CreditHistoryLogControllerFindAll$Params } from '../fn/credit-history-log/credit-history-log-controller-find-all';
import { creditHistoryLogControllerFindById } from '../fn/credit-history-log/credit-history-log-controller-find-by-id';
import { CreditHistoryLogControllerFindById$Params } from '../fn/credit-history-log/credit-history-log-controller-find-by-id';
import { creditHistoryLogControllerGetCreditInfo } from '../fn/credit-history-log/credit-history-log-controller-get-credit-info';
import { CreditHistoryLogControllerGetCreditInfo$Params } from '../fn/credit-history-log/credit-history-log-controller-get-credit-info';
import { creditHistoryLogControllerSearchCursor } from '../fn/credit-history-log/credit-history-log-controller-search-cursor';
import { CreditHistoryLogControllerSearchCursor$Params } from '../fn/credit-history-log/credit-history-log-controller-search-cursor';
import { creditHistoryLogControllerSearchOffset } from '../fn/credit-history-log/credit-history-log-controller-search-offset';
import { CreditHistoryLogControllerSearchOffset$Params } from '../fn/credit-history-log/credit-history-log-controller-search-offset';
import { CreditHistoryLogDto } from '../models/credit-history-log-dto';
import { CreditInfoDto } from '../models/credit-info-dto';
import { CursorPaginationDto } from '../models/cursor-pagination-dto';
import { OffsetPaginationDto } from '../models/offset-pagination-dto';

@Injectable({ providedIn: 'root' })
export class CreditHistoryLogService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `creditHistoryLogControllerFindAll()` */
  static readonly CreditHistoryLogControllerFindAllPath = '/api/creditHistoryLog';

  /**
   * 크레딧 사용 로그 전체 조회.
   *
   * 크레딧 사용 로그 전체를 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `creditHistoryLogControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditHistoryLogControllerFindAll$Response(params?: CreditHistoryLogControllerFindAll$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CreditHistoryLogDto>>> {
    return creditHistoryLogControllerFindAll(this.http, this.rootUrl, params, context);
  }

  /**
   * 크레딧 사용 로그 전체 조회.
   *
   * 크레딧 사용 로그 전체를 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `creditHistoryLogControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditHistoryLogControllerFindAll(params?: CreditHistoryLogControllerFindAll$Params, context?: HttpContext): Observable<Array<CreditHistoryLogDto>> {
    return this.creditHistoryLogControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CreditHistoryLogDto>>): Array<CreditHistoryLogDto> => r.body)
    );
  }

  /** Path part for operation `creditHistoryLogControllerCreate()` */
  static readonly CreditHistoryLogControllerCreatePath = '/api/creditHistoryLog';

  /**
   * 크레딧 사용 로그 생성.
   *
   * 크레딧 사용 로그을(를) 생성합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `creditHistoryLogControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  creditHistoryLogControllerCreate$Response(params: CreditHistoryLogControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<CreditHistoryLogDto>> {
    return creditHistoryLogControllerCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * 크레딧 사용 로그 생성.
   *
   * 크레딧 사용 로그을(를) 생성합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `creditHistoryLogControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  creditHistoryLogControllerCreate(params: CreditHistoryLogControllerCreate$Params, context?: HttpContext): Observable<CreditHistoryLogDto> {
    return this.creditHistoryLogControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreditHistoryLogDto>): CreditHistoryLogDto => r.body)
    );
  }

  /** Path part for operation `creditHistoryLogControllerSearchOffset()` */
  static readonly CreditHistoryLogControllerSearchOffsetPath = '/api/creditHistoryLog/search/offset';

  /**
   * 크레딧 사용 로그 오프셋 기반 조회.
   *
   * 크레딧 사용 로그을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `creditHistoryLogControllerSearchOffset()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditHistoryLogControllerSearchOffset$Response(params: CreditHistoryLogControllerSearchOffset$Params, context?: HttpContext): Observable<StrictHttpResponse<OffsetPaginationDto>> {
    return creditHistoryLogControllerSearchOffset(this.http, this.rootUrl, params, context);
  }

  /**
   * 크레딧 사용 로그 오프셋 기반 조회.
   *
   * 크레딧 사용 로그을(를) 오프셋 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `creditHistoryLogControllerSearchOffset$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditHistoryLogControllerSearchOffset(params: CreditHistoryLogControllerSearchOffset$Params, context?: HttpContext): Observable<OffsetPaginationDto> {
    return this.creditHistoryLogControllerSearchOffset$Response(params, context).pipe(
      map((r: StrictHttpResponse<OffsetPaginationDto>): OffsetPaginationDto => r.body)
    );
  }

  /** Path part for operation `creditHistoryLogControllerSearchCursor()` */
  static readonly CreditHistoryLogControllerSearchCursorPath = '/api/creditHistoryLog/search/cursor';

  /**
   * 크레딧 사용 로그 커서 기반 조회.
   *
   * 크레딧 사용 로그을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `creditHistoryLogControllerSearchCursor()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditHistoryLogControllerSearchCursor$Response(params: CreditHistoryLogControllerSearchCursor$Params, context?: HttpContext): Observable<StrictHttpResponse<CursorPaginationDto>> {
    return creditHistoryLogControllerSearchCursor(this.http, this.rootUrl, params, context);
  }

  /**
   * 크레딧 사용 로그 커서 기반 조회.
   *
   * 크레딧 사용 로그을(를) 커서 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `creditHistoryLogControllerSearchCursor$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditHistoryLogControllerSearchCursor(params: CreditHistoryLogControllerSearchCursor$Params, context?: HttpContext): Observable<CursorPaginationDto> {
    return this.creditHistoryLogControllerSearchCursor$Response(params, context).pipe(
      map((r: StrictHttpResponse<CursorPaginationDto>): CursorPaginationDto => r.body)
    );
  }

  /** Path part for operation `creditHistoryLogControllerGetCreditInfo()` */
  static readonly CreditHistoryLogControllerGetCreditInfoPath = '/api/creditHistoryLog/{clientWorkspaceId}/info';

  /**
   * 고객사 ID로 크레딧 사용 현황을 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `creditHistoryLogControllerGetCreditInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditHistoryLogControllerGetCreditInfo$Response(params: CreditHistoryLogControllerGetCreditInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<CreditInfoDto>> {
    return creditHistoryLogControllerGetCreditInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * 고객사 ID로 크레딧 사용 현황을 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `creditHistoryLogControllerGetCreditInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditHistoryLogControllerGetCreditInfo(params: CreditHistoryLogControllerGetCreditInfo$Params, context?: HttpContext): Observable<CreditInfoDto> {
    return this.creditHistoryLogControllerGetCreditInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreditInfoDto>): CreditInfoDto => r.body)
    );
  }

  /** Path part for operation `creditHistoryLogControllerFindById()` */
  static readonly CreditHistoryLogControllerFindByIdPath = '/api/creditHistoryLog/{id}';

  /**
   * 크레딧 사용 로그 ID 기반 조회.
   *
   * 크레딧 사용 로그을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `creditHistoryLogControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditHistoryLogControllerFindById$Response(params: CreditHistoryLogControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<CreditHistoryLogDto>> {
    return creditHistoryLogControllerFindById(this.http, this.rootUrl, params, context);
  }

  /**
   * 크레딧 사용 로그 ID 기반 조회.
   *
   * 크레딧 사용 로그을(를) ID를 기반으로 조회합니다.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `creditHistoryLogControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  creditHistoryLogControllerFindById(params: CreditHistoryLogControllerFindById$Params, context?: HttpContext): Observable<CreditHistoryLogDto> {
    return this.creditHistoryLogControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreditHistoryLogDto>): CreditHistoryLogDto => r.body)
    );
  }

}
